<template>
  <div class="add_new_inner wrap-surg-add">
    <div class="subtitle center no_mobile">הזן כלים ועזרים לניתוח</div>
    <h2 class="subtitle_inner mobile_only">הזן כלים ועזרים לניתוח:</h2>
    <div class="required-txt desk-center">
      *כוכבית מסמלת את השדות הנדרשים לבחירה
    </div>

    <ValidationObserver ref="analysisForm">
      <form @submit.prevent="onSubmit" name="analysisToolsForm">
        <div
          class="inner_group bg--white desk_inner_width desk-flex desk-flex--top sanit-form analysis-tools-step"
        >
          <div
            v-for="field in fields"
            :key="field.name"
            class="add_new_row flex"
            :class="{
              disabled:
                formData.assistant !== 'מביא אסיסטנט' &&
                field.name === 'assistant_name'
            }"
          >
            <div class="add_new_row_col1">
              {{ field.label }}
              <span class="note mobile_only" v-if="field.note">
                {{ field.note }}
              </span>
            </div>
            <div class="add_new_row_col2">
              <div class="input-opacity desk-block">
                <validation-provider
                  :ref="field.name"
                  :name="field.name"
                  :rules="field.rules"
                  v-slot="{ errors }"
                >
                  <select2
                    v-if="field.type === 'select'"
                    dir="rtl"
                    v-model="formData[field.name]"
                  >
                    <option value="">בחר</option>
                    <option
                      v-for="(option, i) in field.options"
                      :key="i"
                      :value="option.value"
                    >
                      {{ option.text }}
                    </option>
                  </select2>
                  <input
                    v-else-if="field.type === 'input'"
                    :type="field.inputType"
                    v-model="formData[field.name]"
                    :disabled="
                      formData.assistant !== 'מביא אסיסטנט' &&
                        field.name === 'assistant_name'
                    "
                  />
                  <span class="error-message">{{ errors[0] }}</span>
                </validation-provider>
              </div>
              <span class="note no_mobile" v-if="field.note">
                {{ field.note }}
              </span>
            </div>
          </div>

          <div class="add_new_row flex sanit-order">
            <div class="add_new_row_col1">הזמנות</div>
            <div class="add_new_row_col2 w-100">
              <div class="step-4-docs-group sanit-order-field">
                <div class="sur-order-toggle-grid">
                  <div
                    v-for="(request, key) in requestLabels"
                    :key="key"
                    class="sur_order flex flex--start"
                    @click="formData.requests[key] = !formData.requests[key]"
                  >
                    <button
                      type="button"
                      class="sur_order_swipe"
                      :class="{ active: formData.requests[key] }"
                    >
                      <span class="swipe_in ease"></span>
                    </button>
                    <div class="sur_order_tx">{{ request }}</div>
                  </div>
                  <div
                    class="sur_order flex flex--start"
                    :class="{ disabled: isPreSurgeryLocked }"
                    @click="togglePreSurgeryOverride"
                  >
                    <button
                      type="button"
                      class="sur_order_swipe"
                      :class="{ active: formData.pre_surgery_override }"
                    >
                      <span class="swipe_in ease"></span>
                    </button>
                    <div>
                      נדרש טרום ניתוח
                      <div
                        v-show="surgery.start_date"
                        class="text--20 text--error"
                      >
                        לא ניתן לעריכה לאחר שיבוץ הניתוח
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div
            v-for="(note, key) in noteLabels"
            :key="key"
            class="add_new_row flex sanit-note-row"
          >
            <div class="add_new_row_col1">{{ note }}</div>
            <div class="add_new_row_col2 w-100">
              <div class="step-4-docs-group sanit-note-field">
                <div class="input_area_opcity">
                  <textarea
                    v-model="formData[key]"
                    placeholder="פירוט..."
                    autocomplete="off"
                  ></textarea>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="surg-bottom-actions center">
          <button type="submit" class="bt_blue">הבא</button>
        </div>
      </form>
    </ValidationObserver>
  </div>
</template>

<script>
import { mapState, mapMutations, mapGetters } from "vuex";
import surgerySelect from "../../../../../mixins/surgerySelect.json";
import {
  getGeneralResources,
  getImplantsResources,
  combineResources
} from "@/utilities/resources-separator";
import { ENABLE_MEDICAL_CONDITION_INDICATION } from "@/utilities/anesthesia-indication.js";

export default {
  name: "AnalysisTools",
  data() {
    return {
      formData: {
        assistant: "",
        assistant_name: "",
        hospitalization: "",
        anesthesia: "",
        xray_type: "",
        select_frozen_cut: "",
        requests: {
          monitoring_request: false,
          blood: false,
          icu: false,
          tee_request: false,
          navigation_request: false
        },
        resources: "",
        notes: "",
        pre_surgery_override: false
      },
      fields: [
        {
          label: "אסיסטנט*",
          name: "assistant",
          type: "select",
          options: surgerySelect.assistant_status,
          rules: "required",
          note: "בחר צורך באסיסטנט"
        },
        {
          label: "שם האסיסטנט",
          name: "assistant_name",
          type: "input",
          inputType: "text"
        },
        {
          label: "ימי אשפוז*",
          name: "hospitalization",
          type: "select",
          options: surgerySelect.hospitalization,
          rules: "required"
        },
        {
          label: "הרדמה*",
          name: "anesthesia",
          type: "select",
          options: surgerySelect.anesthesia,
          rules: "required",
          note: "בחר צורך במרדים"
        },
        {
          label: "סוג צילום",
          name: "xray_type",
          type: "select",
          options: surgerySelect.xray_type
        },
        {
          label: "חתך קפוא (FS)",
          name: "select_frozen_cut",
          type: "select",
          options: surgerySelect.frozen_cut,
          note: "במידה ויש צורך בFS אנא בחר ביחס למועד הניתוח"
        }
      ],
      requestLabels: {
        monitoring_request: "נדרש ניטור",
        blood: "הזמנת מוצרי דם",
        icu: "אשפוז בטיפול נמרץ",
        tee_request: "נדרש T.E.E.",
        navigation_request: "נדרש ניווט"
      },
      noteLabels: {
        resources: "משאבים נדרשים",
        notes: "הערות"
      }
    };
  },
  computed: {
    ...mapState("Surgery", ["surgery"]),
    ...mapGetters("Surgery", ["isAnesthesiaIndicationRequired"]),

    /**
     * Pre-surgery is fixed once the surgery is scheduled, and while option 3
     * of the anesthesia indication sets it automatically.
     */
    isPreSurgeryLocked() {
      return Boolean(
        this.surgery.start_date ||
          (ENABLE_MEDICAL_CONDITION_INDICATION &&
            this.isAnesthesiaIndicationRequired)
      );
    }
  },
  created() {
    this.formData = {
      assistant: this.surgery.assistant ?? "",
      assistant_name: this.surgery.assistant_name ?? "",
      hospitalization: this.surgery.hospitalization ?? "",
      anesthesia: this.surgery.anesthesia ?? "",
      xray_type: this.surgery.xray_type ?? "",
      select_frozen_cut: this.surgery.select_frozen_cut ?? "",
      requests: {
        monitoring_request: this.surgery.requests?.monitoring_request ?? false,
        blood: this.surgery.requests?.blood ?? false,
        icu: this.surgery.requests?.icu ?? false,
        tee_request: this.surgery.requests?.tee_request ?? false,
        navigation_request: this.surgery.requests?.navigation_request ?? false
      },
      resources: getGeneralResources(this.surgery.resources),
      notes: this.surgery.notes ?? "",
      pre_surgery_override: this.surgery.pre_surgery_override ?? false
    };
  },
  methods: {
    ...mapMutations("Surgery", ["SET_SURGERY", "SET_CURRENT_STEP"]),
    togglePreSurgeryOverride() {
      if (this.isPreSurgeryLocked) return;
      this.formData.pre_surgery_override = !this.formData.pre_surgery_override;
    },
    async onSubmit() {
      const isValid = await this.$refs.analysisForm.validate();

      if (!isValid) {
        this.scrollToFirstError();
        return;
      }

      this.SET_SURGERY({
        ...this.formData,
        resources: combineResources(
          this.formData.resources,
          getImplantsResources(this.surgery.resources)
        )
      });
      this.SET_CURRENT_STEP(5);
    },
    scrollToFirstError() {
      const HEADER_OFFSET = 120;
      const errors = this.$refs.analysisForm.errors;

      for (const fieldName in errors) {
        if (errors[fieldName].length > 0) {
          const ref = this.$refs[fieldName];
          const element = Array.isArray(ref) ? ref[0]?.$el : ref?.$el;

          if (element) {
            const elementTop =
              element.getBoundingClientRect().top + window.scrollY;
            window.scrollTo({
              top: elementTop - HEADER_OFFSET,
              behavior: "smooth"
            });
          }
          break;
        }
      }
    }
  }
};
</script>

<style scoped>
.wrap-surg-add .subtitle,
.wrap-surg-add .subtitle_inner {
  font-weight: 300;
}

.inner_group.analysis-tools-step > .add_new_row .add_new_row_col1 {
  text-align: right;
}

@media screen and (min-width: 1200px) {
  .inner_group.analysis-tools-step {
    display: grid !important;
    grid-template-columns: repeat(3, minmax(0, 1fr));
    align-items: stretch;
    align-content: start;
  }

  .inner_group.analysis-tools-step > .add_new_row.flex {
    width: 100% !important;
    max-width: 100%;
    min-width: 0;
  }

  .inner_group.analysis-tools-step > .add_new_row .add_new_row_col1 {
    align-self: stretch;
  }

  .inner_group.analysis-tools-step > .add_new_row.sanit-order {
    display: flex;
    flex-direction: column;
    align-items: stretch;
    justify-content: flex-start;
    height: 100%;
    min-height: 0;
  }

  .inner_group.analysis-tools-step
    > .add_new_row.sanit-order
    .add_new_row_col2 {
    flex: 1 1 auto;
    display: flex;
    flex-direction: column;
    min-height: 0;
  }

  .inner_group.analysis-tools-step
    > .add_new_row.sanit-order
    .sanit-order-field {
    flex: 1 1 auto;
    display: flex;
    flex-direction: column;
    min-height: 0;
    height: auto;
  }

  .inner_group.analysis-tools-step
    > .add_new_row.sanit-order
    .sur-order-toggle-grid {
    flex: 1 1 auto;
  }

  .inner_group.analysis-tools-step > .add_new_row.sanit-note-row {
    display: flex;
    flex-direction: column;
    align-items: stretch;
    justify-content: flex-start;
    height: 100%;
    min-height: 0;
  }

  .inner_group.analysis-tools-step
    > .add_new_row.sanit-note-row
    .add_new_row_col2 {
    flex: 1 1 auto;
    display: flex;
    flex-direction: column;
    min-height: 0;
  }

  .inner_group.analysis-tools-step
    > .add_new_row.sanit-note-row
    .sanit-note-field {
    flex: 1 1 auto;
    display: flex;
    flex-direction: column;
    min-height: 0;
    height: auto;
  }

  .inner_group.analysis-tools-step
    > .add_new_row.sanit-note-row
    .input_area_opcity {
    flex: 1 1 auto;
    display: flex;
    flex-direction: column;
    min-height: 0;
  }

  .inner_group.analysis-tools-step > .add_new_row.sanit-note-row textarea {
    flex: 1 1 auto;
    width: 100%;
    min-height: 100px;
    height: 100% !important;
    resize: vertical;
    box-sizing: border-box;
  }
}

@media screen and (max-width: 1199px) {
  .analysis-tools-step .add_new_row.sanit-order {
    width: 100% !important;
    max-width: 100%;
  }
}

.sanit-order-field,
.sanit-note-field {
  width: 100%;
}

.sanit-order-field .sur_order {
  font-size: 23px;
}

.sur-order-toggle-grid {
  display: grid;
  grid-template-columns: 1fr;
  column-gap: 1.25rem;
  row-gap: 0;
  align-items: start;
}

.sur-order-toggle-grid .sur_order {
  min-width: 0;
}

@media screen and (min-width: 1200px) {
  .sur-order-toggle-grid {
    grid-template-columns: 1fr 1fr;
  }
}
</style>
